import { isClickableInput } from "@testing-library/user-event/dist/cjs/utils/index.js";
import { GridColumnType } from "../../../data/gridColumnType";

export const BatchCertificatesConfig = {
    columns: [
        {
            name: "",
            fieldName: "select",
            allowShort: false,
            colType: GridColumnType.CHECKBOX,
            colSettings: {
                allowHeaderCheckbox: false,
                headerLabel: "Select All",
                allowEdit: true
            }
        },
        {
            name: "Company Name",
            fieldName: "companyName",
            allowShort: false,
            colType: GridColumnType.LINK,
            colSettings: {
                isOpenNewTab: false,
                url: "$membershipTaskListLink",
            },
        },
        {
            name: "Included Certs",
            fieldName: "certificateNumber",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "Item Code",
            fieldName: "itemCode",
            allowShort: false,
            colType: GridColumnType.Text,
            colSettings: {
                allowLastCheck: true
            }
        },

    ],
};
